import React from "react"
import {BillFile, isBillFileImage, isBillFilePdf} from "../../resources/bills"
import {KeyValueCard} from "../KeyValueCard/KeyValueCard"

interface BillFilePreviewProps {
	billFile?: BillFile
}

function openBillFile(link: string) {
	window.open(link, "_blank", "noopener,noreferrer")
}

function getPdfPreviewUrl(link: string): string {
	const hashParams = "toolbar=0&navpanes=0"
	return link.includes("#") ? `${link}&${hashParams}` : `${link}#${hashParams}`
}

export function BillFilePreview({billFile}: BillFilePreviewProps) {
	if (!billFile?.attributes.link) {
		return null
	}

	const {link, contentType} = billFile.attributes

	return (
		<KeyValueCard title="Bill File">
			{isBillFileImage(billFile) ? (
				<a className="bill-file-preview-link" href={link} target="_blank" rel="noopener noreferrer">
					<img className="bill-file-preview-image" src={link} alt="Bill file preview" />
				</a>
			) : isBillFilePdf(billFile) ? (
				<button
					type="button"
					className="bill-file-preview-pdf-button"
					aria-label="Open bill file in new tab"
					onClick={() => openBillFile(link)}
				>
					<iframe className="bill-file-preview-pdf" src={getPdfPreviewUrl(link)} title="Bill file preview" />
				</button>
			) : (
				<a
					className="bill-file-preview-link bill-file-preview-file-link"
					href={link}
					target="_blank"
					rel="noopener noreferrer"
				>
					View file ({contentType})
				</a>
			)}
		</KeyValueCard>
	)
}
